// Type pour la configuration des IPs nommées
export interface IPConfig {
  [ip: string]: {
    name: string;
    description?: string;
    color?: string;
    lastUpdated?: string;
  };
}

// Fonction pour charger la configuration des IPs
export const loadIPConfig = (): IPConfig => {
  const savedConfig = localStorage.getItem('ipConfig');
  return savedConfig ? JSON.parse(savedConfig) : {};
};

// Fonction pour sauvegarder la configuration des IPs
export const saveIPConfig = (config: IPConfig): void => {
  localStorage.setItem('ipConfig', JSON.stringify(config));
};

// Fonction pour ajouter ou mettre à jour une IP nommée
export const updateIPName = (ip: string, name: string, description?: string, color?: string): IPConfig => {
  const config = loadIPConfig();
  config[ip] = {
    name,
    description: description || '',
    color: color || '',
    lastUpdated: new Date().toISOString()
  };
  saveIPConfig(config);
  return config;
};

// Fonction pour supprimer une IP nommée
export const removeIPName = (ip: string): IPConfig => {
  const config = loadIPConfig();
  delete config[ip];
  saveIPConfig(config);
  return config;
};

// Fonction pour obtenir le nom d'une IP
export const getIPName = (ip: string): string | null => {
  const config = loadIPConfig();
  return config[ip]?.name || null;
};

// Exporter la config par défaut
export default {
  loadIPConfig,
  saveIPConfig,
  updateIPName,
  removeIPName,
  getIPName
}; 